import tw from 'twin.macro'

const Container = tw.div`container mx-auto px-4 sm:(px-0)`

export default Container